import React, { ReactNode } from 'react';
import styles from './GalleryLightbox.module.scss';

type GalleryLightboxCustomSourceProps = {
	children?: ReactNode;
};

export const GalleryLightboxCustomSource = React.forwardRef<HTMLDivElement, GalleryLightboxCustomSourceProps>(({ children }, ref) => {
	return (
		<div className={styles.galleryLightboxCustomSource} ref={ref} style={{ width: '100vw', height: '100vh' }}>
			{children}
		</div>
	);
});
